export const InviteI18n = {
	zh: {

		'invite-single': '邀请添加您为好友',
		'invite-single-btn': '同意',
		'invite-group': '邀请您加入“链上会”群聊',
		'invite-group-btn': '加入群聊',
		'invite-group-title': '“链上会” 群聊分享'
	},
	en: {
		'invite-single': 'wanted to add you as a friend',
		'invite-single-btn': 'Add',
		'invite-group': ' invited you to join group chat',
		'invite-group-btn': 'Join group chat',
		'invite-group-title': '“ChainPal” group chat share'
	},
}